import type { IStore } from '@inter-ikea-kompis/types';
import type { CacheStore } from '@inter-ikea-kompis/utilities';
import { GlobalCacheStore } from '@inter-ikea-kompis/utilities';

import CacheStoreType from '../../enums/CacheStoreType.js';

/**
 * This class is used for storing and loading stores from cache.
 */
export default class StoreCache {
	private readonly locale: string;
	private readonly cache: CacheStore;

	/**
	 * Constructor.
	 *
	 * @param locale Locale.
	 * @param cache Cache store.
	 */
	constructor(locale: string, cache?: CacheStore) {
		this.locale = locale;
		this.cache = cache || new GlobalCacheStore();
	}

	/**
	 * Returns stores.
	 *
	 * @returns Stores.
	 */
	public getStores(): IStore[] {
		return this.cache.getStore(CacheStoreType.store).get(this.getCacheKey()) || null;
	}

	/**
	 * Sets stores.
	 *
	 * @param stores Stores.
	 */
	public addStores(stores: IStore[]): void {
		this.cache.getStore(CacheStoreType.store).set(this.getCacheKey(), stores);
	}

	/**
	 * Removes stores.
	 */
	public clear(): void {
		this.cache.getStore(CacheStoreType.store).delete(this.getCacheKey());
	}

	/**
	 * Returns cache key.
	 *
	 * @returns Cache key.
	 */
	private getCacheKey(): string {
		return this.locale + 'stores';
	}
}
